import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { catchError, from, Observable, switchMap, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { BaseService } from '../services/base.service';
import { KeycloakService } from 'keycloak-angular';
import { ModalService } from '../services/modal.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  skipUrl = ['sign-in', 'olx.ua', 'api.novaposhta.ua'];

  constructor(
    private readonly authService: AuthService,
    private readonly baseService: BaseService,
    private readonly keycloakService: KeycloakService,
    private readonly modalService: ModalService,
    private readonly router: Router,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const schema = this.authService.getSchema();
    let authRequest;
    if (this.skipUrl.some(url => req.url.includes(url))) {
      authRequest = req.clone({
        headers: new HttpHeaders({}),
      });
      return next.handle(authRequest);
    }

    return from(this.keycloakService.getToken())
      .pipe(switchMap((token) => {
        const company = this.baseService.getCompany();
        // if (!company) window.href.
        // if (req.headers.get('Content-Type'))
        authRequest = req.clone({
          setHeaders: {
            'Authorization': `Bearer ${token}`,
            'x-schema': schema,
            'x-company': company || '',
          },
        });
        return next.handle(authRequest).pipe(
          catchError(async (err) => {
            // Check for IP_ACCESS_DENIED error
            const hasIpAccessDenied = (err?.error?.errors || []).some((error: any) =>
              error?.code === 'IP_ACCESS_DENIED'
            );

            if (hasIpAccessDenied) {
              await this.router.navigate(['/ip-access-denied']);
              throw err;
            }

            if (err.status === 401 || err.status === 403) {
              this.authService.logout();
            }

            if (err.status === 400) {
              (err?.error?.errors || []).forEach((error: any) => {
                if ((error?.code || '').includes('TARIFF')) {
                  this.modalService.openTariffUpdate();
                }
              });
            }

            throw err;
          })
        );
      }));
  }
}
